module.exports = __webpack_public_path__ + "img/applySharer_ready.479762ae.png";